module.exports = __webpack_public_path__ + "img/roadmap-pc.c41c0e49.png";